import React from 'react';
import Svg from '../Svg';

const IconCircleCut = ({ ...props }) => (
  <Svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.00011 4.51547C4.58808 6.12999 3 8.87954 3 12C3 15.1205 4.58808 17.87 7.00011 19.4845C9.41379 17.8687 11 15.1191 11 12C11 8.88093 9.4138 6.13131 7.00011 4.51547ZM6.50032 2.47142C3.21224 4.37332 1 7.92831 1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C9.99655 1 8.1182 1.5356 6.50032 2.47142ZM8.998 3.51282C11.4409 5.52945 13 8.58224 13 12C13 15.4178 11.4409 18.4706 8.998 20.4872C9.9369 20.8193 10.9473 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C10.9473 3 9.9369 3.18072 8.998 3.51282Z"
    />
  </Svg>
);

export default IconCircleCut;
